import { create } from 'zustand';

interface SelectionState {
  selectedIds: Set<string>;
  lastSelectedId: string | null;
  toggle: (id: string) => void;
  range: (ids: string[]) => void;
  selectAll: (ids: string[]) => void;
  clear: () => void;
  setLastSelected: (id: string | null) => void;
}

export const useSelectionStore = create<SelectionState>((set) => ({
  selectedIds: new Set<string>(),
  lastSelectedId: null,
  toggle: (id) => set((s) => {
    const next = new Set(s.selectedIds);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    return { selectedIds: next, lastSelectedId: id };
  }),
  range: (ids) => set((s) => {
    const next = new Set(s.selectedIds);
    for (const id of ids) next.add(id);
    return {
      selectedIds: next,
      lastSelectedId: ids[ids.length - 1] ?? s.lastSelectedId,
    };
  }),
  selectAll: (ids) => set({
    selectedIds: new Set(ids),
    lastSelectedId: ids[ids.length - 1] ?? null,
  }),
  clear: () => set({ selectedIds: new Set<string>(), lastSelectedId: null }),
  setLastSelected: (id) => set({ lastSelectedId: id }),
}));
